export const GET_AGE_GATE_CONFIG = "GET_AGE_GATE_CONFIG";
export const GET_AGE_GATE_CONFIG_PENDING = "GET_AGE_GATE_CONFIG_PENDING";
export const GET_AGE_GATE_CONFIG_REJECTED = "GET_AGE_GATE_CONFIG_REJECTED";
export const GET_AGE_GATE_CONFIG_FULFILLED = "GET_AGE_GATE_CONFIG_FULFILLED";
